import React, { useState, FC } from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { UseFormRegisterReturn } from 'react-hook-form';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import styles from './PasswordInputField.module.scss';

interface IPasswordInputFieldProps {
  placeholder: string;
  name?: string;
  error?: boolean;
  className?: string;
  tabIndex?: number;
  register?: UseFormRegisterReturn<any>;
  ref?: any;
  tableInput?: boolean;
  inputWrapperClassName?: string;
  autoComplete?: boolean;
}

/**
 * @param props - The props for the component.
 * @param name - name for the input.
 * @param placeholder - placeholder for the input.
 * @param tabIndex - tab index for the input.
 * @param className - custom class name for the input.
 * @param inputWrapperClassName - custom class name for the input wrapper.
 * @param ref - ref for the input.
 * @param tableInput - Indicate is input using in tab
 * @param autoComplete - Indicates if input need to auto complete.
 * @param error - Indicates error in input.
 * @description - Form input shared component for forms
 * @returns A React component that displays an input.
 */

const PasswordInputField: FC<IPasswordInputFieldProps> = React.forwardRef(
  (props, ref) => {
    const {
      className,
      tableInput,
      error,
      register,
      inputWrapperClassName,
      autoComplete,
      ...rest
    } = props;
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
      setShowPassword((prevState) => !prevState);
    };

    return (
      <div
        className={[
          styles.inputWrapper,
          inputWrapperClassName,
          !tableInput ? styles.default : styles.tableWrapper,
          error && styles.error,
        ].join(' ')}
      >
        <input
          type={showPassword ? 'text' : 'password'}
          ref={ref}
          className={[className].join(' ')}
          {...rest}
          autoComplete={autoComplete ? 'on' : 'new-password'}
        />
        <Tooltip title={showPassword ? 'Hide password' : 'Show password'}>
          <IconButton
            tabIndex={-1}
            size="small"
            aria-label="toggle password visibility"
            className={styles.toggle}
            onClick={togglePasswordVisibility}
          >
            {showPassword ? (
              <VisibilityIcon
                sx={{
                  fontSize: '20px',
                }}
              />
            ) : (
              <VisibilityOffIcon
                sx={{
                  fontSize: '20px',
                }}
              />
            )}
          </IconButton>
        </Tooltip>
      </div>
    );
  }
);

export default PasswordInputField;
